export default "/_next/static/chunks/fonts/Calibri-Bold-a750e4cc7360b2376bc0c29e766f300c.ttf";